const CONFIGURATIONS = "/backoffice/dcir-config";

export const CONFIGURATION_ROUTES = {
  CONFIGURATIONS,
};
